import { Partner } from "./types";

export const commonPartners: readonly Partner[] = [
  {
    id: "binance",
    link: [
      {
        label: "online_support_page",
        href: "https://www.binance.com/en/support",
      },
      {
        label: "online_support_chat",
        href: "https://www.binance.com/en/chat?sourceEntry=33",
      },
    ],
    image: "binance.png",
    opTime: "binance_op_time",
    width: 90,
    height: 32.5,
  },
];
